import { Component } from '@angular/core';

import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { first } from 'rxjs';
import { SessionService } from 'src/app/services/session.service';
import { BaseWizardComponent } from '../base-wizard.component';
import { AcknowledgementNotificationDataModel, IAcknowledgementNotificationDataModel } from '../models/veg-wizard-models';
import { VegWizardDataService } from '../services/veg-wizard-data.service';

@UntilDestroy()
@Component({
  selector: 'app-acknowledge-notification',
  templateUrl: './acknowledge-notification.component.html',
  styleUrls: ['./acknowledge-notification.component.css'],
  imports: [
    ReactiveFormsModule
],
})
export class AcknowledgeNotificationComponent extends BaseWizardComponent {

  form: FormGroup;

  acknowledgementNotificationData: IAcknowledgementNotificationDataModel;
  isValidAcceptedDeclaration = false;

  constructor(
    private formBuilder: FormBuilder,
    private vwds: VegWizardDataService,
    private sessionService: SessionService,
    router: Router) {
    super();
    this.router = router;

    this.acknowledgementNotificationData = this.vwds.getAcknowledgementNotificationData() ?? new AcknowledgementNotificationDataModel();
    this.form = this.formBuilder.group({
      acknowledgementNotificationData: [this.acknowledgementNotificationData?.notificationReferenceNumber]
    });
  }

  finish() {
    this.vwds.clear().pipe(first(), untilDestroyed(this)).subscribe();
    this.sessionService.clearSession();
    this.router.navigate(['/home']).then(() => {
      window.location.reload();
    });
  }

  newLot() {
    this.vwds.renewSessionWithExistingData$()
      .pipe(first(), untilDestroyed(this))
      .subscribe((newSessionId: string) => {
        this.sessionService.startNewSessionIdAfterLodgement(newSessionId);
        this.vwds.clearOrReuseLotAfterSubmission(false);

        this.router.navigate(['/lot-on-plan'])
      });
  }

  currentLot() {
    this.vwds.renewSessionWithExistingData$()
      .pipe(first(), untilDestroyed(this))
      .subscribe((newSessionId: string) => {
        this.sessionService.startNewSessionIdAfterLodgement(newSessionId);
        this.vwds.clearOrReuseLotAfterSubmission(true);

        this.router.navigate(['/select-purpose'])
      });
  }

}
